import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FirebaseService } from '../core/services/firebase.service';
import { OrgContextService } from '../core/services/org-context.service';

export function requirePermission(permission: string, fallbackUrl = '/'): CanActivateFn {
  return async () => {
    const orgContext = inject(OrgContextService);
    const router = inject(Router);

    if (inject(FirebaseService).regionError()) return router.parseUrl('/region-unavailable');
    if (!orgContext.currentOrg()) {
      return router.parseUrl('/new');
    }

    const hasPermission = await orgContext.checkPermission(permission);
    return hasPermission || router.parseUrl(fallbackUrl);
  };
}

export function requireOrg(): CanActivateFn {
  return async () => {
    const orgContext = inject(OrgContextService);
    const router = inject(Router);

    // Data residency: the org exists but its region can't be reached — say so
    // instead of bouncing to onboarding or falling back to another org.
    if (inject(FirebaseService).regionError()) return router.parseUrl('/region-unavailable');

    const org = orgContext.currentOrg();
    return org ? true : router.parseUrl('/new');
  };
}
